export default __webpack_public_path__ + "images/icons/chevron-left.svg";